// extracted by mini-css-extract-plugin
export default {"maitanance_overlay":"j0R4t","maitanance_image":"oVhyy","maitanance_container":"aLirt","maitanance_text":"Wxm4I"};